export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">关于我们</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">了解小辣椒影院的故事与初心</p>
        <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-8">
          <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-start">
            <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-primary-500 flex-shrink-0 mx-auto md:mx-0">
              <i className="ri-movie-2-line text-2xl md:text-3xl text-background-50"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-3 text-center md:text-left">小辣椒影院 · 让每个人都能自由观影</h3>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                小辣椒影院创立于 2020 年，是一个致力于为全球华语用户提供免费高清影视内容的在线观影平台。
                我们深知优质影视内容对人们生活的重要性，因此始终坚持完全免费的理念，让每一位影迷都能毫无负担地享受观影乐趣。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                平台汇聚了超过 10000 部电影、电视剧、综艺和动漫资源，涵盖国内外热门内容。无论是院线大片、经典老片、
                热播剧集还是高分纪录片，在小辣椒影院都能找到。我们采用先进的视频加速和智能分发技术，确保高清画质下也能流畅播放不卡顿。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                小辣椒影院持续更新和优化，每日同步上线最新影视资源，努力成为你最值得信赖的免费在线影院。
                感谢每一位影迷的支持与陪伴，我们将不忘初心，继续前行。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}